import React from "react";
import DocumentTitle from "react-document-title";
import * as E from "./ElementsStyles";
import { ThemeContext } from "@fluentui/react-theme-provider";
import ElementService from "../../../services/ElementsService";
import { useHistory, useParams } from "react-router-dom";
import styles from "./indes.module.sass";
import { DefaultButton } from "@fluentui/react";
import TicketSupport from "../../TicketSupport/TicketSupport";
import { TicketSupportContainer } from "../../TicketSupport/TicketSupport.style";
import { ScreenStepType } from "../../TicketSupport/TicketSupportConstants";
import { TicketSupportError } from "../../../services/TicketSupportService";
import useTicketSupport from "../../../hooks/useTicketSupport";

const ConvenienceTestElementsContract = () =>
{
    const { savingPlanId } = useParams<any>();
    const history = useHistory();
    const loadContractFirstTime = React.useRef<boolean>(false);
    const [contract, setContract] = React.useState<string>("Cargando el contrato...");
    const theme = React.useContext(ThemeContext);
    const [bottom, setBottom] = React.useState(false);
    const [ticketError, setTicketError] = React.useState<TicketSupportError>(
    {
        status: false,
        message: "",
    });
    const ticketSupport = useTicketSupport(
    {
        component: "ConvenienceTestElementsContract",
        screenName: ScreenStepType.LecturaContratoElements,
        ticketError,
        savingPlanId,
    });

    const handleScroll = (event: any) =>
    {
        const bottom = event.target.scrollHeight - event.target.scrollTop <= event.target.clientHeight + 1;
        setBottom(bottom);
    };

    React.useEffect(() =>
    {
        if(loadContractFirstTime.current === false)
        {
            ElementService.getElementContract().then((response: string) =>
            {
                if(response !== undefined)
                {
                    loadContractFirstTime.current = true;
                    setContract(response);
                }
                else
                {
                    // contrato viene vacío
                    setTicketError(
                    {
                        status: false,
                        message: "No se encontró el contrato.",
                    });
                    setContract("No se ha podido cargar el contrato. Puedes ponerte en contacto con nosotros a través del formulario.");
                    ticketSupport.setShowSupportForm(true);
                }
            })
            .catch((error) =>
            {
                setContract("No se ha podido cargar el contrato. Puedes ponerte en contacto con nosotros a través del formulario.");
                ticketSupport.setShowSupportForm(true);
                console.error("Error al obtener contrato:", error);
                setTicketError(
                {
                    status: false,
                    message: "Error al obtener el contrato. [ERROR]: " + JSON.stringify(error)
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            {/* Soporte */}
            <TicketSupportContainer>
                <TicketSupport {...ticketSupport} />
            </TicketSupportContainer>

            <DocumentTitle title="IronIA - Elements - Contrato">
                <React.Fragment>
                    <E.ContractPanel theme={theme} onScroll={handleScroll} className={styles.content}>
                        {contract !== undefined &&
                        (
                            <div dangerouslySetInnerHTML={{ __html: contract }} />
                        )}
                    </E.ContractPanel>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 text-right">
                            <DefaultButton className="button tiny-primary-button" id={styles.signButton}
                                disabled={!bottom}
                                onClick={() => history.push(`/elements-contract/confirm/${savingPlanId}`)}
                            >
                                Firmar
                            </DefaultButton>
                        </div>
                    </div>
                </React.Fragment>
            </DocumentTitle>

        </>
    );
};

export default ConvenienceTestElementsContract;